import classes from './stepProgressiveBar.module.css';
import { FC } from 'react';

type step = 'step1' | 'step2' | 'step3';
const StepProgressiveBar: FC<{ step: step }> = ({ step }) => {
  console.log('step: ', step);
  return (
    <div className={classes.container}>
      <ul className={classes.progressbar}>
        <li className={`${['step1', 'step2', 'step3'].includes(step) ? 'active' : ''}`}>Step 1</li>
        <li className={`${['step2', 'step3'].includes(step) ? 'active' : ''}`}>Step 2</li>
        <li className={`${['step3'].includes(step) ? 'active' : ''}`}>Step 3</li>
      </ul>
    </div>
  );
};

export default StepProgressiveBar;
